import React from 'react'

export type SVGButtonProps = {
  title: string
  link: string
  target?: string
  className?: string
}

export const SVGButton = ({
  title,
  link,
  target,
  className = 'frw-button frw-button--3'
}: SVGButtonProps) => (
  <a
    aria-label={title}
    className={className}
    href={link}
    target={target || '_self'}
  >
    {title}
  </a>
)
